import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PrivateLibraryService } from 'src/app/core/services/private-library.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { GiftPublicationModalComponent } from '../../material-detail/gift-modal/gift-modal.component';
import { ErrorMessageComponent } from '../error-message/error-message.component';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { SuccessMessageComponent } from '../success-message/success-message.component';
import { AuthService } from 'src/app/core/services/auth.service';
import { UploadSpaceModalComponent } from '../../wipod/upload-publication/upload-space-modal/upload-space-modal.component';

@Component({
  selector: 'app-accepted-rejected-gift',
  templateUrl: './accepted-rejected-gift.component.html',
  styleUrls: ['./accepted-rejected-gift.component.scss']
})
export class AcceptedRejectedGiftComponent implements OnInit {
  currentUser;
  savetop: boolean = false;
  constructor(
    private activeModal: NgbActiveModal,
    private _privateLibraryService: PrivateLibraryService,
    private _spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private _authService: AuthService
  ) { }
  @Input() public content_id;
  @Input() public activeTab;
  @Input() public contentName;
  @Input() public mode;
  @Input() public sa_user_id;
  hidePopup: boolean = false;
  contents = [];
  imagePath = environment.url;

  ngOnInit() {
    if (!this.activeTab)
      this.activeTab = 'pending';
    if (!this.mode) {
      this.mode = 'main_account'
    }
    this.loadContentDetails();
    this.currentUser = this._authService.getCurrentUser();
  }

  closeDialog() {
    if (this.savetop) {
      this.activeModal.close(true);
    } else {
      this.activeModal.close();
    }

  }

  loadContentDetails() {
    this._spinner.show();
    let params = "status=" + this.activeTab + "&content_id=" + this.content_id;
    if(this.mode == 'parent'){
      params += '&sa_user_id=' + this.sa_user_id;
    }
    this._privateLibraryService.getGifedContentDetails(params).subscribe((response) => {
      if (response.success) {
        this.contents = response.data.gift_records;
      }
      this._spinner.hide();
    }, (error) => {
      this._spinner.hide();
    });
  }

  fetchTab(item) {
    this.activeTab = item;
    this.loadContentDetails();
  }

  regiftContent(item) {
    const modalRef = this.modalService.open(GiftPublicationModalComponent, { windowClass: 'right white custom-width', backdrop: 'static', keyboard: false });
    modalRef.componentInstance.regift = item.recipient_id
    modalRef.componentInstance.content = item.content;
    modalRef.componentInstance.giftId = item.id;
    modalRef.result.then((result) => {
      if (result) {
        this.activeModal.close(true);
      }
    }, (reason) => {

    });
  }

  saveToPrivate(item) {
    this._spinner.show();
    this._privateLibraryService.saveGiftToPrivateLibrary(item.id).subscribe((response) => {
      this._spinner.hide();
      if (response.success) {
        this.hidePopup = true;
        const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
        modalRef.componentInstance.message = response.message;
        modalRef.result.then((result) => {
          this.hidePopup = false;
        }, (reason) => {
          this.hidePopup = false;
        });
        this.savetop = true;
        this.fetchTab(this.activeTab);
      } else if (response.errors) {
        const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
        modalRef.componentInstance.contentAccessError = response.errors;
        modalRef.componentInstance.isRedirectRequired = false;
      } else {
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.GIFT_SAVE_PRIVATE;
      }
    }, (error) => {
      this._spinner.hide();
      const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
      modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.GIFT_SAVE_PRIVATE;
    });
  }
}
